<div *ngIf="loading" class="changelog-loading">
	<mat-spinner diameter="32"></mat-spinner>
	<span class="loading-label">Loading change history…</span>
</div>

<div *ngIf="!loading">
	<div class="changelog-exports">
		<button mat-stroked-button color="warn" class="export-btn" (click)="buildHtmlAndExport('pdf')" [disabled]="!changelog_f.length || exportingxlsx">
			<svg *ngIf="exportingpdf" class="spinner" width="16px" height="16px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
			<span *ngIf="!exportingpdf">
				<i class="fa fa-file-pdf-o"></i>
				PDF
			</span>
		</button>
		<button mat-stroked-button color="primary" class="export-btn" (click)="buildHtmlAndExport('xslx')" [disabled]="!changelog_f.length || exportingpdf">
			<svg *ngIf="exportingxlsx" class="spinner" width="16px" height="16px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
			<span *ngIf="!exportingxlsx">
				<i class="fa fa-file-excel-o"></i>
				XLSX
			</span>
		</button>
		
	</div>

	<div class="changelog-toolbar">
		<div class="changelog-filters">
			<mat-form-field appearance="outline">
				<mat-label>Search</mat-label>
				<input matInput [formControl]="searchbar" (keyup)="filterlogs()"/>
			</mat-form-field>

			<mat-form-field appearance="outline" class="filter-type">
				<mat-label>Type</mat-label>
				<mat-select [formControl]="changelog_type">
					<mat-option [value]="'all'">All</mat-option>
					<mat-option [value]="'insert'">Insert</mat-option>
					<mat-option [value]="'update'">Update</mat-option>
					<mat-option [value]="'delete'">Delete</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="filter-type" *ngIf="multiple_branches">
				<mat-label>Branch</mat-label>
				<mat-select [formControl]="branchcode">
					<mat-option [value]="'all'">All</mat-option>
					<mat-option [value]="branch" *ngFor="let branch of multiple_branches">
						{{branch}}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="filter-dates">
				<mat-label>Changes Between</mat-label>
				<mat-date-range-input [rangePicker]="picker" (keyup.enter)="updatetimeframe();">
					<input matStartDate [formControl]="fromdateCtrl" placeholder="Start date">
					<input matEndDate [formControl]="todateCtrl" placeholder="End date">
				</mat-date-range-input>
				<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-date-range-picker #picker></mat-date-range-picker>
			</mat-form-field>

			<button class="export-btn m-auto" mat-icon-button (click)="resetFilters()">
				<mat-icon>clear_all</mat-icon>
			</button>
		</div>

		<div class="changelog-record-count compact-pager" [ngClass]="{ 'pos-abs': this.multiple_branches}">
			<mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
		</div>
	</div>
	
	<ng-container *ngIf="changelog_f.length">
		<div class="changelog-table-wrapper">
			<table class="table table-hover changelog-table">
				<thead>
					<tr>
						<th>Date</th>
						<th>Changed By</th>
						<th>Type</th>
						<th>Table</th>
						<th>Branch</th>
						<th>Field</th>
						<th>Old Value</th>
						<th>New Value</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let entry of dataObs | async"
						[ngClass]="{
							'row-insert': entry.type === 'insert',
							'row-update': entry.type === 'update',
							'row-delete': entry.type === 'delete'
						}">
						<td class="cell-date text-nowrap">{{ entry.changed_at | date:'short' }}</td>
						<td class="cell-user">{{ entry.changed_by }}</td>
						<td>
							<span class="type-badge"
								[ngClass]="{
									'badge-insert': entry.type === 'insert',
									'badge-update': entry.type === 'update',
									'badge-delete': entry.type === 'delete'
								}">
								{{ entry.type }}
							</span>
						</td>
						<td class="cell-table">{{ entry.table }}</td>
						<td class="cell-table">{{entry.branchcode || '-'}}</td>
						<td class="cell-field"><code>{{ entry.field_changed }}</code></td>
						<td class="cell-value old">{{ entry.old_value || '-' }}</td>
						<td class="cell-value new">{{ entry.new_value || '-' }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</ng-container>

	<div *ngIf="!changelog_f.length" class="changelog-empty">
		<span class="changelog-empty-icon">📋</span>
		<p *ngIf="!changelog.length && !changelog_f.length">No change history found for this customer</p>
		<p *ngIf="changelog.length && !changelog_f.length">No change history found for applied filters</p>
	</div>
</div>
